import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { checkmarkIcon, circleQuestion } from '../../icons';
import { SidePanelService } from '../side-panel/side-panel.service';

export enum INDICATA_PRICE_VALUATIONS {
    NOT_AVAILABLE = 'NotAvailable',
    CHEAP = 'Cheap',
    FAIR = 'Fair',
    GOOD = 'Good',
    LITTE_EXPENSIVE = 'LittleEpensive',
    EXPENSIVE = 'Expensive',
}

@Component({
    selector: 'app-product-item-valuation-badge',
    template: `
        <ng-container [ngSwitch]="isClickable">
            <button type="button" *ngSwitchCase="true" class="price-valuation-badge button--minimal" [ngClass]="{'price-valuation-badge--minimal': minimalLayout}" (click)="showInfo()">
                <ng-container *ngTemplateOutlet="valuationValue"></ng-container>
                <ng-container *ngIf="!minimalLayout">
                    <span>&dash;</span>
                    <span>
                        {{ 'filterpage.indicata_valuation____generic_text' | translate }}
                        <span class="price-valuation-badge__indicata-text">Indicata</span>
                    </span>
                    <i class="price-valuation-info__icon">${circleQuestion}</i>
                </ng-container>
            </button>
            <div *ngSwitchCase="false" class="price-valuation-badge button--minimal" [ngClass]="{'price-valuation-badge--minimal': minimalLayout}">
                <ng-container *ngTemplateOutlet="valuationValue"></ng-container>
                <ng-container *ngIf="!minimalLayout">
                    <span>&dash;</span>
                    <span>
                        {{ 'filterpage.indicata_valuation____generic_text' | translate }}
                        <span class="price-valuation-badge__indicata-text">Indicata</span>
                    </span>
                    <i class="price-valuation-info__icon">${circleQuestion}</i>
                </ng-container>
            </div>
        </ng-container>

        <ng-template #valuationValue>
            <i class="price-valuation-badge__icon" [ngClass]="[valuationClass]">${checkmarkIcon}</i>
            <span class="price-valuation-badge__value" [ngSwitch]="valuationString">
                <ng-container *ngSwitchCase="indicataValuations.NOT_AVAILABLE">
                    {{ 'filterpage.indicata_valuation____coming_soon' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="indicataValuations.EXPENSIVE">
                    {{ 'filterpage.indicata_valuation____expensive' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="indicataValuations.LITTE_EXPENSIVE">
                    {{ 'filterpage.indicata_valuation____little_expensive' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="indicataValuations.FAIR">
                    {{ 'filterpage.indicata_valuation____fair' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="indicataValuations.GOOD">
                    {{ 'filterpage.indicata_valuation____good' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="indicataValuations.CHEAP">
                    {{ 'filterpage.indicata_valuation____cheap' | translate }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                    {{ 'filterpage.indicata_valuation____coming_soon' | translate }}
                </ng-container>
            </span>
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductItemValuationBadgeComponent implements OnInit {
    @Input() valuationString?: INDICATA_PRICE_VALUATIONS | string | null;
    @Input() minimalLayout?: boolean = true;
    @Input() isClickable?: boolean = false;
    indicataValuations = INDICATA_PRICE_VALUATIONS;
    valuationClass: string | undefined;

    constructor(
        private sidepanelService: SidePanelService
    ) {}

    ngOnInit(): void {
        this.valuationClass = this.valuationString ? `price-valuation-badge--${this.valuationString?.toLowerCase()}` : `price-valuation-badge--${this.indicataValuations.NOT_AVAILABLE.toLowerCase()}`;
    }

    showInfo() {
        this.sidepanelService.showIndicataInfoSidePanel();
    }
}
